import designData from "../data/designdata.json";
import "../styles/design.scss";
import { useState, useEffect } from 'react'; 
import { useNavigate } from "react-router-dom";

// Add { spotlightOnly = false } as a prop
function Designs({ spotlightOnly = false }) {
    const navigate = useNavigate();
  const [selectedDesign, setSelectedDesign] = useState(null);

  // Filter logic based on the prop
  const displayedDesigns = spotlightOnly 
    ? designData.filter(design => design.spotlight) 
    : designData;

  useEffect(() => {
    const handleOverflow = (isLocked) => {
      const value = isLocked ? 'hidden' : 'auto';
      document.documentElement.style.overflow = value;
      document.body.style.overflow = value;
    };

    if (selectedDesign) {
      handleOverflow(true);
    } else {
      handleOverflow(false);
    }

    return () => handleOverflow(false);
  }, [selectedDesign]);

  const closeModal = () => setSelectedDesign(null);

  return (
    <div className="project-page">
      <div className="design-grid">
        {displayedDesigns.map((design, index) => (
          <div 
            key={index} 
            className="design-card" 
            onClick={() => setSelectedDesign(design)}
          >
            <div className="image-container">
              <img 
                src={design["preview-img"]} 
                alt={design.name} 
                className="preview-image"
              />
            </div>
            <p className="design-description">{design.description}</p>
          </div>
        ))}
      </div>

      {selectedDesign && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={closeModal}>&times;</button>
            
            <div className="modal-header">
              <p>{selectedDesign.description}</p>
            </div>

            <div className="modal-images">
              {selectedDesign.images.map((imgUrl, idx) => (
                <img key={idx} src={imgUrl} alt={`${selectedDesign.name} detail ${idx}`} />
              ))}
            </div>
          </div>
        </div>
      )}

      {!spotlightOnly && (
        <button
          type="button"
          className="more-projects"
          onClick={() => navigate("/about")}
          aria-label="View more projects"
        >
          Learn about me
        </button>
      )}
    </div>
  );
};

export default Designs;